module.exports = __webpack_public_path__ + "static/media/18.d47827a0.png";